import React from 'react';
import { makeStyles, Select, MenuItem } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { makeURL } from '../../helperFunctions';
import { getTransformedYourBrandAndConsumersData } from '../../helperFunctions/getSurveysWithExtractedFields';
import useViewportWidth from '../../myHooks/useViewportWidth';

const useStyles = makeStyles(theme => ({
  smallTitle: {
    fontSize: '18px',
    marginBottom: '5px',
    fontWeight: 300,
    color: '#585858',
    whiteSpace: 'nowrap',
  },
  dropdown: {
    '& svg': {
      top: '5px !important',
    },

    '& ul': {
      maxHeight: '100px',
      overflowY: 'scroll',
    },
  },
  selectBrand: {
    outline: 'none',
    border: 'none',
    fontSize: '22px',
    color: '#19989B',
    '&:focus': {
      backgroundColor: 'transparent',
    },

    '@media (max-width: 768px)': {
      fontSize: '18px',
    },

    '@media (min-width: 1300px)': {
      fontSize: '32px',
    },
  },
  selectCompetitiveBrand: {
    outline: 'none',
    border: 'none',
    fontSize: '22px',
    color: '#19989B',
    '&:focus': {
      backgroundColor: 'transparent',
    },

    '@media (max-width: 768px)': {
      fontSize: '18px',
    },

    '@media (min-width: 1300px)': {
      fontSize: '32px',
    },
  },
  selectBuyer: {
    color: '#AB8628',
    outline: 'none',
    border: 'none',
    fontSize: '22px',
    '&:focus': {
      backgroundColor: 'transparent',
    },

    '@media (max-width: 768px)': {
      fontSize: '18px',
    },

    '@media (min-width: 1300px)': {
      fontSize: '32px',
    },
  },
  selectSocialPost: {
    outline: 'none',
    border: 'none',
    fontSize: '22px',
    color: '#19989B',
    '&:focus': {
      backgroundColor: 'transparent',
    },

    '@media (max-width: 768px)': {
      fontSize: '18px',
      marginBottom: '24px',
    },

    '@media (min-width: 1300px)': {
      fontSize: '32px',
    },
  },
  selectDisabled: {
    outline: 'none',
    border: 'none',
    fontSize: '22px',
    color: 'lightgray',
    '&:focus': {
      backgroundColor: 'transparent',
    },

    '@media (max-width: 768px)': {
      fontSize: '18px',
    },

    '@media (min-width: 1300px)': {
      fontSize: '32px',
    },
  },
  menuItem: {
    minWidth: '200px',
    position: 'relative',
  },
  invisible: {
    opacity: 0,
    pointerEvents: 'none',
    visibility: 'none',
    height: '0px',
    padding: '0px',
  },
  viewAllBtn: {
    content: '',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'red',
    opacity: 0,
  },
}));

//screen-width: text-length
const titleTextLengthConfig = {
  wide: {
    width: 1250,
    textLength: 40,
  },
  medium: {
    width: 878,
    textLength: 25,
  },
  small: {
    width: 450,
    textLength: 25,
  },
  extraSmall: {
    width: 100,
    textLength: 15,
  },
};

const HeaderSelector = ({
  selectedId,
  data,
  sameIndustryData,
  type,
  setPickedId,
  pickedBatchCountry,
  redirect,
  bgColor = '#19989B',
  disabled,
  hideHeader,
}) => {
  const classes = useStyles();
  const history = useHistory();

  let titleText = 'Brand Persona';

  if (type == 'buyer') {
    titleText = 'Buyer Persona';
  } else if (type == 'social') {
    titleText = 'Marketing Campaign';
  } else if (type == 'competitive') {
    titleText = 'Select Brand';
  }

  let selectorOptions = [];

  if (type == 'brand') {
    selectorOptions = data.brandPersonas;
  } else if (type == 'buyer') {
    selectorOptions = data.buyerPersonas;
  } else if (type == 'social') {
    selectorOptions = data.socialPosts;
  } else if (type == 'competitive') {
    if (!sameIndustryData) {
      let pickedBrand = data.batchBrands[pickedBatchCountry].find(brands => brands.id === selectedId);
      selectorOptions = [pickedBrand];
    } else {
      let sameIndustryDataNamesOnly = sameIndustryData.map(data => data.name);
      selectorOptions = data.batchBrands[pickedBatchCountry].filter(
        brands => sameIndustryDataNamesOnly.indexOf(brands.name) !== -1 || brands.id === selectedId,
      );
    }
  } else if (type == 'brandConsumers') {
    const transformedYourBrandAndConsumersData = getTransformedYourBrandAndConsumersData(
      data.yourBrandAndConsumersData[pickedBatchCountry],
      pickedBatchCountry,
    );
    const selectedBrandName = selectedId.split('/')[0];

    let repeatedBrandNames = [selectedBrandName];
    selectorOptions = transformedYourBrandAndConsumersData.filter(({ brandName, id }) => {
      if (brandName === selectedBrandName) return id === selectedId;

      if (!repeatedBrandNames.includes(brandName)) {
        repeatedBrandNames.push(brandName);
        return true;
      } else return false;
    });

    repeatedBrandNames = [];
  }

  const onChangeHandler = e => {
    if (e.target.value) {
      setPickedId(e.target.value);
    }
  };

  const onLastItemClick = e => {
    if (redirect) {
      let redirectURL = '/brand-personas/all';
      if (type == 'buyer') {
        redirectURL = '/buyer-personas/all';
      } else if (type == 'social') {
        redirectURL = '/marketing-content/all';
      } else if (type == 'competitive') {
        redirectURL = '/competitive-set-brands/all';
      } else if (type == 'brandConsumers') {
        redirectURL = '/brand-consumers/all';
      }
      history.push(makeURL(redirectURL));
      return;
    }
  };
  const screenWidth = useViewportWidth();

  const getFormattedSocMedPostTitle = title => {
    let screenType =
      screenWidth >= titleTextLengthConfig.wide.width
        ? 'wide'
        : screenWidth >= titleTextLengthConfig.medium.width
        ? 'medium'
        : screenWidth >= titleTextLengthConfig.small.width
        ? 'small'
        : 'extraSmall';

    const wantedTextLength = titleTextLengthConfig[screenType].textLength;
    return title?.length > wantedTextLength ? title.substring(0, wantedTextLength).concat('...') : title;
  };
  return (
    <div>
      {hideHeader ? null : <h5 className={classes.smallTitle}>{titleText}</h5>}
      {selectedId && selectorOptions && (
        <Select
          id="headerSelector"
          variant="standard"
          value={selectedId ? selectedId : ''}
          disabled={selectorOptions.length === 1 || disabled}
          classes={{
            select: disabled
              ? classes.selectDisabled
              : type == 'brand'
              ? classes.selectBrand
              : type == 'social'
              ? classes.selectSocialPost
              : type == 'competitive' || type == 'brandConsumers'
              ? classes.selectCompetitiveBrand
              : classes.selectBuyer,
          }}
          className={classes.dropdown}
          name="headerSelector"
          onChange={onChangeHandler}
          disableUnderline
          MenuProps={{
            style: {
              maxHeight: '350px',
            },
          }}>
          {selectorOptions.map((item, index) => {
            return (
              <MenuItem
                className={`${classes.menuItem} ${index > 4 && redirect ? classes.invisible : ''}`}
                key={item.id}
                value={item.id}>
                {type == 'social'
                  ? getFormattedSocMedPostTitle(item.Post_Title)
                  : type == 'competitive'
                  ? getFormattedSocMedPostTitle(item.name)
                  : type == 'brandConsumers'
                  ? getFormattedSocMedPostTitle(item.brandName)
                  : getFormattedSocMedPostTitle(item.Name)}
              </MenuItem>
            );
          })}
          {redirect && (
            <MenuItem
              className={`${classes.menuItem}`}
              onClick={onLastItemClick}
              style={{ background: bgColor, color: '#fff' }}>
              <span className={classes.viewAllBtn}></span>
              View all
            </MenuItem>
          )}
        </Select>
      )}
    </div>
  );
};

export default HeaderSelector;
